import notifStatus from './constants/notifStatus';

class Notifs {
  constructor() {
    this.count = 0;
    this.subscriber = null;
    this.closeSubscriber = null;
    this.notifs = [];
  }
  critical(title, msg, duration) {
    return this.send({ title, msg, type: notifStatus.critical, duration });
  }
  error(title, msg, duration) {
    return this.send({ title, msg, type: notifStatus.error, duration });
  }
  warning(title, msg, duration) {
    return this.send({ title, msg, type: notifStatus.warning, duration });
  }
  success(title, msg, duration) {
    return this.send({ title, msg, type: notifStatus.success, duration });
  }
  info(title, msg, duration) {
    return this.send({ title, msg, type: notifStatus.info, duration });
  }
  sms(title, msg, duration, data) {
    return this.send({ title, msg, type: notifStatus.sms, duration, ...data });
  }
  email(title, msg, duration, data) {
    return this.send({
      title, msg, type: notifStatus.email, duration, ...data
    });
  }
  popUp(title, msg, duration, data) {
    return this.send({
      title, msg, type: notifStatus.popUp, duration, ...data
    });
  }
  subscribe(cb) {
    if (typeof cb !== 'function') {
      throw new Error('Not a function');
    }
    if (this.subscriber !== null) {
      throw new Error('Someone has already subscribe to notifications');
    }
    this.subscriber = cb;
    return () => {
      this.subscriber = null;
    };
  }
  /**
   * S'abonne aux fermetures de notifications déclenchées à distance
   * (ex: fin d'appel Ringover). Un seul abonné, comme subscribe().
   * @param {(predicate: (notif: Object) => boolean) => void} cb
   */
  subscribeClose(cb) {
    if (typeof cb !== 'function') {
      throw new Error('Not a function');
    }
    if (this.closeSubscriber !== null) {
      throw new Error('Someone has already subscribe to notification closes');
    }
    this.closeSubscriber = cb;
    return () => {
      this.closeSubscriber = null;
    };
  }
  /**
   * Ferme les notifications correspondant au prédicat, qu'elles soient
   * déjà affichées ou encore en attente. Côté rendu, la fermeture passe
   * par l'animation de sortie existante (NotifTransition).
   * @param {(notif: Object) => boolean} predicate
   */
  closeMatching(predicate) {
    this.notifs = this.notifs.filter((n) => !predicate(n));
    if (this.closeSubscriber) {
      this.closeSubscriber(predicate);
    }
  }
  send(notif) {
    const finalNotif = { ...notif, id: this.count++ };
    this.notifs.push(finalNotif);
    this.subscriber();
    return finalNotif;
  }
  consume() {
    return this.notifs.shift();
  }
}

export default new Notifs();
